/**
 * @name ErrorsGrid
 * @description Componente para los registros con error de las cargas masivas
 * @author Ricardo Guerra
 */

import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import styled from 'styled-components';

import { Report } from '@components';
import { Flex, MUI, Unicons, Typography } from '@styles';

const ErrorsGrid = (props) => {
  const { columns, errors } = props;

  // Colors
  const RED_70 = '#D50032B3';
  // const RED_10 = '#D500321A';

  return (
    <>
      <Styled.ErrorBox>
        <Unicons.CircleTimes size="28" color={RED_70} style={{ marginRight: '8px' }} />
        <Flex.Col>
          <Typography.Text color={RED_70}><Typography.Medium>{i18n.t('HttpResponse.error')}</Typography.Medium></Typography.Text>
          <Typography.Small>{i18n.t('MassiveUploads.errorUpload')}</Typography.Small>
        </Flex.Col>
      </Styled.ErrorBox>
      <MUI.Box padding="16px">
        <Report
          showHeader={false}
          columns={columns}
          rows={errors}
          rowsLength={errors.length}
        />
      </MUI.Box>
    </>
  );
};

ErrorsGrid.propTypes = {
  // Arreglo de columnas para el componente Report.
  columns: PropTypes.array.isRequired,
  // Arreglo de errores encontrados en el JSON.
  errors: PropTypes.array
};

// *************************************
// STYLED COMPONENTS
// *************************************

const Styled = {};

Styled.ErrorBox = styled(Flex.Row)`
  margin: 16px;
  padding: 16px;
  border-radius: 6px;
  border: 2px solid #D50032B3; // Red 70%
  background-color: #D500321A; // Red 10%
`;

export default ErrorsGrid;